'use client';

import { Button } from '@ahafood/ui/components/button';
import { Image } from '@ahafood/ui/components/image';
import { Input } from '@ahafood/ui/components/input';
import { assetPrefix } from '@ahm/api-wrappers-core';
import { cn } from '@ahm/common-helpers';
import { ChevronDown, Search } from 'lucide-react';
import { useParams } from 'next/navigation';
import { useEffect, useMemo } from 'react';
import { useOrderListSheet } from '@/app/[locale]/order-list/order-list-sheet-context';
import { ROUTES } from '@/config/router';
import { useStoreCitySheet } from '@/contexts/store-city-sheet-context';
import { usePathname, useRouter } from '@/i18n/routing';
import { trackEvent } from '@/lib/event-tracking';
import { useIsMobile } from '@/lib/is-mobile';
import { useAiFoodOrderStore, useAuthStore } from '@/store';

export default function HeaderFilter() {
  const pathname = usePathname();
  const params = useParams();
  const citySlug = Array.isArray(params.city) ? params.city[0] : params.city;
  const router = useRouter();
  const { openSheet } = useOrderListSheet();
  const { openCitySheet, isNavigating } = useStoreCitySheet();
  // const searchParams = useSearchParams();
  // const lat = searchParams.get('lat')
  //   ? parseFloat(searchParams.get('lat')!)
  //   : undefined;
  // const lng = searchParams.get('lng')
  //   ? parseFloat(searchParams.get('lng')!)
  //   : undefined;

  const isMobile = useIsMobile();
  const cityId = useAiFoodOrderStore.use.city_id();
  const cityName = useAiFoodOrderStore.use.city_name();
  const address = useAiFoodOrderStore.use.address();
  // const setAddress = useAiFoodOrderStore.use.setAddress();
  const { isAuthenticated } = useAuthStore();

  const addressSelected = useMemo(() => {
    if (cityId && !address) {
      return cityName ?? undefined;
    }
    if (address && cityId) {
      return address.address;
    } else {
      return 'Nhập vị trí của bạn';
    }
  }, [address, cityId, cityName]);

  // Only open city sheet if there's no address and not currently navigating
  useEffect(() => {
    if (!address && !isNavigating) {
      openCitySheet();
    }
  }, [address, isNavigating, openCitySheet]);

  const handleClipboardCheckClick = () => {
    trackEvent('click_button', {
      action_time: Math.floor(Date.now() / 1000),
      button_name: 'order_list',
    });
    openSheet();
  };

  return (
    <>
      <div className="flex w-full flex-col justify-end gap-3 md:flex-row md:gap-4">
        <div
          className={cn('relative w-full md:max-w-96', {
            // hidden: pathname === ROUTES.search,
          })}
        >
          {/* {address ? (
            <Button
              variant="ghost"
              size="sm"
              className="absolute right-4 top-3 translate-x-1/2 size-5 bg-white p-0 hover:bg-neutral-20 md:top-5"
              aria-label="Clear input"
              onClick={() => {
                setAddress(null);
              }}
            >
              <X className="size-5" />
            </Button>
          ) : null} */}
          <label className="absolute left-[18px] top-2 flex flex-none items-center text-xs font-medium text-neutral-70 md:top-3">
            Vị trí nhận món
            <ChevronDown className="ml-1" color="orange" size={16} />
          </label>
          <Input
            className="h-12 md:h-14 w-full justify-start truncate rounded-xl border-neutral-20 bg-white/80 pl-4 pr-10 text-sm font-bold hover:bg-white md:max-w-96"
            value={addressSelected}
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onChange={() => {}}
            aria-haspopup="listbox"
            style={{
              paddingTop: 25,
            }}
            onClick={() => openCitySheet()}
          />
        </div>
        {pathname === ROUTES.search ? null : (
          <div className="relative flex w-full flex-row flex-nowrap items-center gap-3">
            <Search className="absolute left-4 top-1/2 size-6 flex-none -translate-y-1/2 z-10" />
            <div className="w-full">
              <Input
                onClick={() => {
                  router.push(`/${citySlug}/danh-sach-cua-hang?focus=1`);
                }}
                className={cn(
                  'inline-flex w-full items-center h-12 md:h-14 justify-start truncate whitespace-nowrap rounded-xl border border-neutral-20 bg-white/80 px-4 py-2 pl-12 pr-12 text-sm font-bold ring-offset-background transition-colors hover:bg-white hover:text-accent-foreground hover:border-primary-40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:border-none focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 md:flex-1 md:text-base',
                  { 'bg-white h-12': pathname === ROUTES.search }
                )}
                placeholder="Bạn muốn ăn gì?"
              />
            </div>
            {isAuthenticated && !isMobile && (
              <Button
                variant="ghost"
                className="px-1 h-full [&_svg]:size-5 text-primary-50 flex flex-col text-[8px] font-bold gap-0  md:text-xs rounded-lg bg-white border border-primary-40"
                onClick={handleClipboardCheckClick}
              >
                {/* <ClipboardCheck />
                Đơn hàng */}
                <Image
                  src={`${assetPrefix}/static/images/order-history.png`}
                  alt="order-history"
                  width={20}
                  height={20}
                />
                Đơn hàng
              </Button>
            )}
          </div>
        )}
      </div>
    </>
  );
}
